import React, {  useEffect,  useReducer, useState } from "react";
import { useSelector } from "react-redux";
import {Collapse} from 'react-bootstrap';
import { Link } from "react-router-dom";
import {MenuList} from './Menu';
import {useScrollPosition} from "@n8tb1t/use-scroll-position";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active : "",
  activeSubmenu : "",
}

const SideBar = () => {
  const [state, setState] = useReducer(reducer, initialState);
  const { auth } = useSelector((state) => state.auth);
  const [userPolicies , setUserPolicies ] = useState([]);

  const handleMenuActive = status => {		
    setState({active : status});			
    if(state.active === status){				
      setState({active : ""});
    }   
  }
  const handleSubmenuActive = (status) => {		
    setState({activeSubmenu : status})
    if(state.activeSubmenu === status){
      setState({activeSubmenu : ""})			
    }    
  }

  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true)
    useScrollPosition(
        ({ prevPos, currPos }) => {
          const isShow = currPos.y > prevPos.y
          if (isShow !== hideOnScroll) setHideOnScroll(isShow)
        },
        [hideOnScroll]
    )

  // ForAction Menu
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1]; 

  const hasAccess = (itemPolicies) => {
    if (!itemPolicies || itemPolicies.length === 0) return true;
    return itemPolicies.some(policy => userPolicies.includes(policy));
  };

  useEffect(() => {
    setUserPolicies(auth?.userPolicy?.policy)
  },[auth]);

  useEffect(() => {
    MenuList.forEach((data) => {
      data.content?.forEach((item) => {        
        if(path === item.to){         
          setState({active : data.title})          
        }
        item.content?.forEach(ele => {
          if(path === ele.to){
            setState({activeSubmenu : item.title, active : data.title})
          }
        })
      })
  })
  },[path]);
    
  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.filter(main => hasAccess(main.policies)).map((data, index) => {
            let menuClass = data.classsChange;

            if (menuClass === "menu-title") {
              return <li className={menuClass} key={index}>{data.title}</li>;
            }

            const visibleSubItems = data.content?.filter(sub => hasAccess(sub.policies));
            const hasDirectLink = !!data.to;
            const hasSubMenu = visibleSubItems && visibleSubItems.length > 0;

            // Hide menu if no direct link and no submenu
            if (!hasDirectLink && (!hasSubMenu || visibleSubItems.length === 0)) return null;

            return (
              <li className={`has-menu ${state.active === data.title ? 'mm-active' : ''}${data.to === path ? 'mm-active' : ''}`} key={index}>
                {/* Main menu link (direct or with submenu) */}
                {hasDirectLink ? (
                  <Link
                    to={`/${data.to}`}
                    className={`ai-icon${hasSubMenu ? ' has-arrow' : ''}`}
                    onClick={() => hasSubMenu && handleMenuActive(data.title)}
                  >
                    {data.iconStyle}
                    <span className="nav-text">{data.title}</span>
                    {data.update && <span className="badge badge-xs style-1 badge-danger ms-2">{data.update}</span>}
                  </Link>
                ) : (
                  <Link
                    to="#"
                    className="has-arrow ai-icon"
                    onClick={() => handleMenuActive(data.title)}
                  >
                    {data.iconStyle}
                    <span className="nav-text">{data.title}</span>
                    {data.update && <span className="badge badge-xs style-1 badge-danger ms-2">{data.update}</span>}
                  </Link>
                )}

                {/* Submenu rendering */}
                {hasSubMenu && (
                  <Collapse in={state.active === data.title}>
                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                      {visibleSubItems.map((subItem, subIndex) => {
                        const visibleInnerItems = subItem.content?.filter(child => hasAccess(child.policies)) || [];
                        return (
                          <li key={subIndex} className={`${state.activeSubmenu === subItem.title ? "mm-active" : ""}${subItem.to === path ? 'mm-active' : ''}`}>
                            {subItem.content && visibleInnerItems.length > 0 ? (
                              <>
                                <Link to={subItem.to} className={subItem.hasMenu ? 'has-arrow' : ''} onClick={() => handleSubmenuActive(subItem.title)}>
                                  {subItem.title}
                                </Link>
                                <Collapse in={state.activeSubmenu === subItem.title}>
                                  <ul className="mm-show">
                                    {visibleInnerItems.map((child, childIndex) => (
                                      <li key={childIndex}>
                                        <Link className={`${path === child.to ? "mm-active" : ""}`} to={child.to}>{child.title}</Link>
                                      </li>
                                    ))}
                                  </ul>
                                </Collapse>
                              </>
                            ) : (
                              <Link to={subItem.to} className={`${subItem.to === path ? 'mm-active' : ''}`}>
                                {subItem.title}
                              </Link>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </Collapse>
                )}
              </li>
            );
          })}
        </ul>
        {/* <div className="copyright">
          <p><strong>Real Estate</strong> © {date.getFullYear()} All Rights Reserved</p>
        </div> */}
      </div>
    </div>
  );
}

export default SideBar;